import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { performStepUpMfa } from './thunks';
import { MfaState, StepUpMfaResult } from './types';

export const initialState: MfaState = {
  mfaUserId: null,
  service: '',
  dialogOpen: false,
  dialogState: 'verifying',
  errorMessage: '',
  actionType: 'window',
};

export const mfaSlice = createSlice({
  name: '@@common/mfa',
  initialState,
  reducers: {
    closeMfaDialog: (state) => {
      state.dialogOpen = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(performStepUpMfa.pending, (state, action) => {
      state.dialogOpen = true;
      state.dialogState = 'verifying';
      state.errorMessage = '';
      state.mfaUserId = initialState.mfaUserId;
      state.actionType = action.meta.arg.actionType;
      state.service = action.meta.arg.service;
    });
    builder.addCase(performStepUpMfa.fulfilled, (state, action: PayloadAction<StepUpMfaResult>) => {
      state.mfaUserId = action.payload.userId;
      state.service = action.payload.service;
      state.dialogState = 'success';
    });
    builder.addCase(performStepUpMfa.rejected, (state, action) => {
      state.dialogState = 'error';
      state.errorMessage = action.payload || action.error.message || 'Verification failed.';
    });
  },
});

export const { closeMfaDialog } = mfaSlice.actions;
